
import axios from "axios"
import { baseUrl, config, requestID, getUser, configFileUpload } from "../common/utils"

const busId = "bus_id_b96c58e8adabb47c000dc8dc5c02900f"
const branchId = "bra_id_b96c58e8adabb47c038dc8dc5c00009m"

export async function getOnboardingProgress(employeeId: string) {
  try {
    const response = await axios.post(
      `${baseUrl()}onboardings/getEmployeeStatus`,
      {
        employeeId,
        requestID: requestID(),
      },
      config,
    )
    console.log("Onboarding progress response:", response)

    return response.data.data

    throw new Error("Failed to fetch onboarding progress")
  } catch (error) {
    console.error("Error fetching onboarding progress:", error)
    throw error
  }
}

export async function getRequiredDocuments(employeeId: string) {
  try {
    const response = await axios.post(
      `${baseUrl()}onboardings/getEmployeeRequiredDocuments`,
      {
     
        employeeId,
        requestID: requestID(),
      },
      config,
    )
    console.log("Required documents response:", response)

    if (response.data) {
      return response.data.data
    }

    throw new Error("Failed to fetch required documents")
  } catch (error) {
    console.error("Error fetching required documents:", error)
    throw error
  }
}

export async function getUploadedDocuments(employeeId: string, busID?: string, branchID?: string, documentId?: string) {
  try {
    const response = await axios.post(
      `${baseUrl()}onboardings/getUploadedDocuments`,
      {
        employeeId,
        requestID: requestID(),
        business_id: busID,
        branch_id: branchID,
        document_id: documentId,
      },
      config,
    )
    console.log("Uploaded documents response:", response)

    if (response.data) {
      return response.data.data
    }

    return []
  } catch (error) {
    console.error("Error fetching uploaded documents:", error)
    return []
  }
}

export async function updateUploadedDocumentStatus(
  employeeId: string,
  busID?: string,
  branchID?: string,
  documentId?: string,
  newStatus?: "approved" | "rejected",
  OId?: string, 
) {
  try {
    const response = await axios.post(
      `${baseUrl()}onboardings/updateUploadedDocumentStatus`,
      {
        employeeId,
        requestID: requestID(),
        business_id: busID,
        branch_id: branchID,
        documentId: documentId,
        status: newStatus,
        onboarding_document_id: OId, 
        updatedBy: getUser().userData.user_id,
      },
      config,
    )
    console.log("Update document status response:", response)

    if (response.data && response.data.status) {
      return response.data.data
    }

    throw new Error("Failed to update document status")
  } catch (error) {
    console.error("Error updating document status:", error)
    throw error
  }
}


export async function uploadDocument(employeeId: string, documentId: string, file: File, onboardingDocumentId: string) {

  console.log(file)
  try {
    const formData = new FormData()
    formData.append("file", file)
    formData.append("employeeId", employeeId)
    formData.append("documentId", documentId)
    formData.append("onboarding_document_id", onboardingDocumentId)
    formData.append("requestID", requestID())
    formData.append("business_id", busId)
    formData.append("branch_id", branchId)

    for (const [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`)
    }

    const response = await axios.post(`${baseUrl()}onboardings/uploadDocument`, formData, 
      config
      
    )
    console.log("Upload document response:", response)
    // if (response.data) {
    //   return response.data.data
    // }

    //throw new Error("Failed to upload document")
  } catch (error) {
    console.error(error)
    throw error
  }
}

const handleGetAllOrientationTasks = async () => {
    try {
      const response = await axios.post(`${baseUrl()}onboardings/getAllOrientationTasks`,
       {
         requestID: requestID(),
         
       }, config
      )
      console.log("API Response:", response)
      return response.data.data
    } catch (error) {
      console.error("Error fetching orientation tasks:", error)
      throw new Error("Failed to fetch orientation tasks")
    }
  }



export async function getEmployeeOrientationTasks() {
  try {
    const response = await axios.post(
      `${baseUrl()}onboardings/getEmployeeOrientationTasks`,
      {
        
        requestID: requestID(),
    
      },
      config,
    )
// console.log("Orientation tasks response:", response)
    if (response.data) {
      return response.data.data
    }

    throw new Error("Failed to fetch orientation tasks")
  } catch (error) {
    console.error("Error fetching orientation tasks:", error)
    throw error
  }
}


export async function getOrientationTasks() {
  try {
    const response = await axios.post(
      `${baseUrl()}onboardings/getAllOrientationTasks`,
      {
        
        requestID: requestID(),
    
      },
      config,
    )
// console.log("Orientation tasks response:", response)
    if (response.data) {
      return response.data.data
    }

    throw new Error("Failed to fetch orientation tasks")
  } catch (error) {
    console.error("Error fetching orientation tasks:", error)
    throw error
  }
}




export async function completeOrientationTask(employeeId: string, taskId: string, notes?: string) {
  try {
    const response = await axios.post(
      `${baseUrl()}onboardings/completeOrientationTask`,
      {
        employeeId,
        notes,
        taskId,
        completedBy: getUser().userData.user_id,
        requestID: requestID(),
      },
      config,
    )
// console.log("Complete orientation task response:", response)
    // if (response.data && response.data.status == "success") {
    //   return response.data.
    // }

    // throw new Error("Failed to complete orientation task")
  } catch (error) {
    console.error("Error completing orientation task:", error)
    throw error
  }
}

// New function for OnboardingOrientation
export async function submitOrientationCompletion(employeeId: string, completedTasks: any[], notes?: string) {
  try {
    const response = await axios.post(
      `${baseUrl()}onboarding/submitOrientationCompletion`,
      {
        employeeId,
        completedTasks,
        notes,
        completedBy: getUser().userData.user_id,
        requestID: requestID(),
      },
      config,
    )

    if (response.data && response.data.success) {
      return response.data.data
    }

    throw new Error("Failed to submit orientation completion")
  } catch (error) {
    console.error("Error submitting orientation completion:", error)
    throw error
  }
}

export async function getOnboardingCourses() {
  try {
    const response = await axios.post(
      `${baseUrl()}onboardings/getEmployeeCourses`,
      {
        // employeeId,
        requestID: requestID(),
        business_id: busId,
        branch_id: branchId,
      },
      config,
    )
     console.log("Onboarding courses response:", response)
    if (response.data) {
      console.log(response.data.data)
      return response.data.data
    }

    throw new Error("Failed to fetch onboarding courses")
  } catch (error) {
    console.error("Error fetching onboarding courses:", error)
    throw error
  }
}

// Alias for backward compatibility
export const getCourses = getOnboardingCourses

// New function for OnboardingCourses
export async function startCourse(courseId: string) {
  // console.log("Starting course with ID:", courseId)
  try {
    const response = await axios.post(
      `${baseUrl()}onboardings/markAttendance`,
      {
        
        course_id: courseId,
        // startedBy: getUser().userData.user_id,
        requestID: requestID(),
      },
      config,
    )
    console.log("Start course response:", response)

    if (response.data) {
      return response.data
    }

    throw new Error("Failed to start course")
  } catch (error) {
    console.error("Error starting course:", error)
    throw error
  }
}

// New function for OnboardingCourses
export async function getCourseContent(courseId: string) {
  try {
    const response = await axios.post(
      `${baseUrl()}onboarding/getCourseContent`,
      {
        courseId,
        requestID: requestID(),
      },
      config,
    )

    if (response.data && response.data.success) {
      return response.data.data
    }

    throw new Error("Failed to fetch course content")
  } catch (error) {
    console.error("Error fetching course content:", error)
    throw error
  }
}

export async function completeCourse(courseId: string, score?: number) {
  console.log("Completing course with ID:", courseId, "Score:", score)
  try {
    const response = await axios.post(
      `${baseUrl()}onboardings/markAttendanceCompleted`,
      {
        course_id: courseId,
        score,
        // completedBy: getUser().userData.user_id,
        requestID: requestID(),
      },
      config,
    )
    console.log("Complete course response:", response)

    if (response.data.message === "Attendance recorded") {
      return response.data.data
    }

    throw new Error("Failed to complete course")
  } catch (error) {
    console.error("Error completing course:", error)
    throw error
  }
}

export async function getEmployeeProfile() {
  try {
    const response = await axios.post(
      `${baseUrl()}users/getprofile_bc`,
      {
      
        requestID: requestID(),
      },
      config,
    )
    console.log("Employee profile response:", response)

    if (response.data) {
      return response.data.data
    }

    throw new Error("Failed to update employee profile")
  } catch (error) {
    console.error("Error updating employee profile:", error)
    throw error
  }
}

export async function uploadProfilePhoto(employeeId, files) {
  try {
    const response = await axios.post(
      `${baseUrl()}users/getprofile_bc`,
      {
        employeeId,
        files,
      
        requestID: requestID(),
      },
      config,
    )
    console.log("Employee profile response:", response)

    if (response.data) {
      return response.data.data
    }

    throw new Error("Failed to update employee profile")
  } catch (error) {
    console.error("Error updating employee profile:", error)
    throw error
  }
}


export async function updateEmployeeProfile(employeeId: string, profileData: any) {
  try {
    const response = await axios.post(
      `${baseUrl()}onboarding/updateProfile`,
      {
        employeeId,
        profileData,
        updatedBy: getUser().userData.user_id,
        requestID: requestID(),
      },
      config,
    )

    if (response.data && response.data.success) {
      return response.data.data
    }

    throw new Error("Failed to update employee profile")
  } catch (error) {
    console.error("Error updating employee profile:", error)
    throw error
  }
}

export async function generateOnboardingCertificate(employeeId: string) {
  try {
    const response = await axios.post(
      `${baseUrl()}users/createCertificate`,
      {
        employeeId,
        requestID: requestID(),
      },
      config,
    )

    console.log("Generate certificate response:", response)

    if (response.data) {
      return response.data
    }

    throw new Error("Failed to generate certificate")
  } catch (error) {
    console.error("Error generating certificate:", error)
    throw error
  }
}

export async function getUserCertificate() {
  try {
    const response = await axios.post(
      `${baseUrl()}users/getUserCertificate`,
      {
        
        requestID: requestID(),
      },
      config,
    )

    console.log("Generate certificate response:", response)

    if (response.data) {
      return response.data.data
    }

    throw new Error("Failed to generate certificate")
  } catch (error) {
    console.error("Error generating certificate:", error)
    throw error
  }
}

// Alias for backward compatibility
export const generateCertificate = generateOnboardingCertificate

// New function for OnboardingCertificate
export async function downloadCertificate(employeeId: string, certificateId: string) {
  try {
    const response = await axios.post(
      `${baseUrl()}onboarding/downloadCertificate`,
      {
        employeeId,
        certificateId,
        requestID: requestID(),
      },
      {
        ...config,
        responseType: "blob", // Important for file downloads
      },
    )

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", `onboarding-certificate-${employeeId}.pdf`)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)

    return true
  } catch (error) {
    console.error("Error downloading certificate:", error)
    throw error
  }
}

// HR Functions for HROnboardingView
export async function getAllOnboardingEmployees() {
  try {
    const response = await axios.post(
      `${baseUrl()}onboarding/getAllEmployees`,
      {
        requestID: requestID(),
      },
      config,
    )

    if (response.data && response.data.success) {
      return response.data.data
    }

    throw new Error("Failed to fetch onboarding employees")
  } catch (error) {
    console.error("Error fetching onboarding employees:", error)
    throw error
  }
}

export async function completeOrientationTaskBulk(employeeIds: string[], taskIds: string[], notes?: string) {
  try {
    const response = await axios.post(
      `${baseUrl()}onboarding/completeOrientationTaskBulk`,
      {
        employeeIds,
        taskIds,
        notes,
        completedBy: getUser().userData.user_id,
        requestID: requestID(),
      },
      config,
    )

    if (response.data && response.data.success) {
      return response.data.data
    }

    throw new Error("Failed to complete orientation tasks in bulk")
  } catch (error) {
    console.error("Error completing orientation tasks in bulk:", error)
    throw error
  }
}

export async function sendRequiredDocuments(
  employeeIds: string[],
  documentIds: string[],
  message?: string,
  busID?: string,
  branchID?: string,
) {
  try {
  
    const response = await axios.post(
      `${baseUrl()}onboardings/sendRequiredDocuments`,
      {
        employeeIds,
        documentIds,
        message,
        sentBy: getUser().userData.user_id,
        requestID: requestID(),
        business_id: busID,
        branch_id: branchID,
      },
      config,
    )

    console.log("Send required documents response:", response)

    if (response.data && response.status === 200) {
      return response.data
    }

    throw new Error("Failed to send required documents")
  } catch (error) {
    console.error("Error sending required documents:", error)
    throw error
  }
}

// NEW: Set Orientation Tasks for employees
export async function setOrientationTasks(
  employeeIds: string[],
  taskIds: string[],
  message?: string,
  busID?: string,
  branchID?: string,
) {
  try {
    // console.log("Setting orientation tasks for employees:", employeeIds)
    // console.log("Task IDs:", taskIds)
    // console.log("Message:", message, "Bus ID:", busID, "Branch ID:", branchID)

    const response = await axios.post(
      `${baseUrl()}onboardings/setOrientationTasks`,
      {
        employeeIds,
        taskIds,
        message,
        sentBy: getUser().userData.user_id,
        requestID: requestID(),
        business_id: busID,
        branch_id: branchID,
      },
      config,
    )

    console.log("Set orientation tasks response:", response)

    if (response.data && response.status === 200) {
      return response.data
    }

    throw new Error("Failed to set orientation tasks")
  } catch (error) {
    console.error("Error setting orientation tasks:", error)
    throw error
  }
}

// NEW: Send Onboarding Courses to employees
export async function sendOnboardingCourses(
  employeeIds: string[],
  courseIds: string[],
  message?: string,
  busID?: string,
  branchID?: string,
) {
  try {
    // console.log("Sending onboarding courses for employees:", employeeIds)
    // console.log("Course IDs:", courseIds)
    // console.log("Message:", message, "Bus ID:", busID, "Branch ID:", branchID)


    const response = await axios.post(
      `${baseUrl()}onboardings/sendOnboardingCourses`,
      {
        employeeIds,
        courseIds,
        message,
        sentBy: getUser().userData.user_id,
        requestID: requestID(),
        business_id: busID,
        branch_id: branchID,
      },
      config,
    )

    console.log("Send onboarding courses response:", response)

    if (response.data && response.status === 200) {
      return response.data
    }

    throw new Error("Failed to send onboarding courses")
  } catch (error) {
    console.error("Error sending onboarding courses:", error)
    throw error
  }
}

export async function sendOnboardingReminder(employeeIds: string[], reminderType: string, message?: string) {
  try {
    const response = await axios.post(
      `${baseUrl()}onboarding/sendReminder`,
      {
        employeeIds,
        reminderType,
        message,
        sentBy: getUser().userData.user_id,
        requestID: requestID(),
      },
      config,
    )

    if (response.data && response.data.success) {
      return response.data.data
    }

    throw new Error("Failed to send onboarding reminder")
  } catch (error) {
    console.error("Error sending onboarding reminder:", error)
    throw error
  }
}
